import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { InventoryProvider } from './context/InventoryContext';
import { AnalyticsProvider } from './context/AnalyticsContext';
import { ChatProvider } from './context/ChatContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Models from './pages/Models';
import ModelDetail from './pages/ModelDetail';
import Inventory from './pages/Inventory';
import VehicleDetail from './pages/VehicleDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Parts from './pages/Parts';
import Financing from './pages/Financing';
import BuildPrice from './pages/BuildPrice';
import ChatBot from './components/ChatBot';
import './App.css';

function App() {
  return (
    <AnalyticsProvider>
      <InventoryProvider>
        <ChatProvider>
          <Router>
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/models" element={<Models />} />
                  <Route path="/models/:id" element={<ModelDetail />} />
                  <Route path="/inventory" element={<Inventory />} />
                  <Route path="/vehicle/:id" element={<VehicleDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/parts" element={<Parts />} />
                  <Route path="/financing" element={<Financing />} />
                  <Route path="/build-your-audi/:id?" element={<BuildPrice />} />
                </Routes>
              </main>
              <Footer />
              <ChatBot />
            </div>
          </Router>
        </ChatProvider>
      </InventoryProvider>
    </AnalyticsProvider>
  );
}

export default App;